let initialState = {
    // family: requestedFamily,
    // family: '',
    isLoading: true,
    loadedComponents: [],
    competitors: [],
    classes: [],
    assignee: '',
    assigneeType: '',
    loadedAssignee: '',
    assigneeInfos: {},
    // currentPage: '',
    concepts: [],
    cpc: '',
    loadedCpc: '',
    cpcInfos: {
        cpc: {},
        ipc: {}
    },
    assignees: [],
    inventors: [],
    inventor: '',
    loadedInventor: '',
    inventorInfos: {},
    pa: '',
    links: [],
    pvstotals: {},
    pvspubs: [],
    pvspubs_orig: null,
    currentSystem: 'cpc'
};

var store = new Vuex.Store({

    state: initialState,

    mutations: {

        resetStore(state) {
            for (let f in state) {
                Vue.set(state, f, initialState[f]);
            }
        },

        showLoading: function(state) {
            state.isLoading = true;
        },

        hideLoading: function(state) {
            state.isLoading = false;
        },

        addLoadedComponent: function(state, payload) {
            state.loadedComponents.push(payload);
        },

        saveClasses: function(state, payload) {
            state.classes = payload;
        },

        saveCompetitors: function(state, payload) {
            state.competitors = payload;
        },

        saveAssigneeDetails: function(state, payload) {
            state.assignee = payload[0];
            state.assigneeType = payload[1];
        },

        changeLoadedAssignee: function(state, payload) {
            state.loadedAssignee = payload;
        },

        storeAssigneeInfos: function(state, payload) {
            state.assigneeInfos[payload.assignee] = payload.data;
        },

        saveConcepts: function(state, payload) {
            state.concepts = payload;
        },

        saveCpc: function(state, payload) {
            state.cpc = payload;
        },

        changeLoadedCpc: function(state, payload) {
            state.loadedCpc = payload;
        },

        storeCpcInfos: function(state, payload) {
            state.cpcInfos[payload.system][payload.cpc] = payload.data;
        },

        saveAssignees: function(state, payload) {
            state.assignees = payload;
        },

        saveInventors: function(state, payload) {
            state.inventors = payload;
        },

        saveInventor: function(state, payload) {
            state.inventor = payload;
        },

        changeLoadedInventor: function(state, payload) {
            state.loadedInventor = payload;
        },

        storeInventorInfos: function(state, payload) {
            state.inventorInfos[payload.inventor] = payload.data;
        },

        storePA: function(state, payload) {
            state.pa = payload;
        },

        storeLinks: function(state, payload) {
            state.links.push(payload);
        },

        storePVSTotals: function(state, payload) {
            state.pvstotals = payload;
        },

        storePVSPubs: function(state, payload) {
            state.pvspubs = payload;
        },

        changeCurrentSystem: function(state, payload) {
            state.currentSystem = payload;
        },

    },

    actions: {

        GET_ASSIGNEE({
            commit,
            dispatch,
            state
        }, payload) {
            return new Promise((resolve, reject) => {
                axios.get('?page=getData&action=getPA', {
                        params: {
                            family: payload
                        }
                    })
                    .then(res => {
                        commit('storePA', res.data);
                        commit('saveAssigneeDetails', [res.data, 'assignee']);
                        resolve(res.data);
                    })
                    .catch(err => {
                        reject(err)
                    })
            });
        }

    },

    getters: {

        companyLinks: (state) => (name) => {
            return state.links.find(company => company.name == name) || {};
        },

        loadedComponents: (state) => {
            return state.loadedComponents || [];
        },

        classes: (state) => {
            return state.classes || [];
        },

        system: (state) => {
            return state.currentSystem || [];
        },

        pa: (state) => {
            return state.pa || null;
        }
    }
});
